import { User } from 'lucide-react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

export const OnboardingStepPersonal = ({ personalInfo, setPersonalInfo }) => (
  <div className="space-y-4">
    <div className="flex items-center gap-2 mb-4">
      <User className="h-5 w-5 text-[#7B1F2A]" />
      <h3 className="text-lg font-semibold">Personal Information</h3>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <Label>Full Name *</Label>
        <Input
          value={personalInfo.full_name}
          onChange={(e) => setPersonalInfo({ ...personalInfo, full_name: e.target.value })}
          placeholder="John Smith"
          data-testid="onboard-fullname"
        />
      </div>
      <div>
        <Label>Email *</Label>
        <Input
          type="email"
          value={personalInfo.email}
          onChange={(e) => setPersonalInfo({ ...personalInfo, email: e.target.value })}
          disabled
          className="bg-slate-100"
        />
      </div>
      <div>
        <Label>Phone</Label>
        <Input
          value={personalInfo.phone}
          onChange={(e) => setPersonalInfo({ ...personalInfo, phone: e.target.value })}
          placeholder="+1 (555) 123-4567"
          data-testid="onboard-phone"
        />
      </div>
      <div>
        <Label>Extension</Label>
        <Input
          value={personalInfo.phone_extension}
          onChange={(e) => setPersonalInfo({ ...personalInfo, phone_extension: e.target.value })}
          placeholder="123"
          data-testid="onboard-extension"
        />
      </div>
      <div>
        <Label>Mobile</Label>
        <Input
          value={personalInfo.mobile}
          onChange={(e) => setPersonalInfo({ ...personalInfo, mobile: e.target.value })}
          placeholder="+1 (555) 987-6543"
        />
      </div>
      <div>
        <Label>Job Title</Label>
        <Input
          value={personalInfo.job_title}
          onChange={(e) => setPersonalInfo({ ...personalInfo, job_title: e.target.value })}
          placeholder="IT Manager"
        />
      </div>
      <div>
        <Label>Preferred Contact Method</Label>
        <Select
          value={personalInfo.preferred_contact_method}
          onValueChange={(v) => setPersonalInfo({ ...personalInfo, preferred_contact_method: v })}
        >
          <SelectTrigger><SelectValue /></SelectTrigger>
          <SelectContent className="bg-white">
            <SelectItem value="email">Email</SelectItem>
            <SelectItem value="phone">Phone</SelectItem>
            <SelectItem value="mobile">Mobile</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label>Preferred Language</Label>
        <Select
          value={personalInfo.preferred_language}
          onValueChange={(v) => setPersonalInfo({ ...personalInfo, preferred_language: v })}
        >
          <SelectTrigger><SelectValue /></SelectTrigger>
          <SelectContent className="bg-white">
            <SelectItem value="en">English</SelectItem>
            <SelectItem value="fr">Français</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  </div>
);
